module.exports = __webpack_public_path__ + "static/img/swiper1.3cbd2f1.png";


//////////////////
// WEBPACK FOOTER
// ./static/swiper1.png
// module id = wV4q
// module chunks = 1